import { useEffect } from "react";

/**
 * Updates document.title for SPA route changes (Google search-result tab title).
 * Restores the default brand title on unmount.
 */
const DEFAULT_TITLE = "HouseEntry — Verified Properties in Delhi NCR";

export default function usePageTitle(title) {
  useEffect(() => {
    if (!title) return;
    const prev = document.title;
    document.title = title;
    return () => {
      document.title = prev || DEFAULT_TITLE;
    };
  }, [title]);
}
